import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import columnWidthsTofr from './helpers/columnWidthsTofr'

const Container = styled.div`
  display: grid;
  grid-template-columns: ${props => columnWidthsTofr(props.columnWidths)};
  background: #75AFB6;
  padding: 5px 10px;
`
const Header = styled.div`
  font-weight: bold;
  font-size: 11pt;
  color: white;
  display: flex;
  align-items: center;
`
const ClickableHeader = styled(Header)`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
const TableHeader = ({ columnWidths, columns }) => {
  return (
    <Container columnWidths={columnWidths}>
      {
        columns.map(column => {
          const { title, onClick } = column
          if (!onClick) {
            return <Header key={title}>{title}</Header>
          } else {
            return (
              <ClickableHeader key={title} onClick={onClick}>
                {title} &#9660;
              </ClickableHeader>
            )
          }
        })
      }
    </Container>
  )
}

TableHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func
  })),
  columnWidths: PropTypes.arrayOf(PropTypes.number)
}

export default TableHeader